import { useQuery } from '@apollo/client'
import React, { useEffect, useRef, useState } from 'react'
import { GET_ALL_USERS_RATINGS } from '../../../../graphql/Catalog/UsersRating/usersRating'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import Box from '../../../Global/Box'
import LayoutTable from '../../../Global/LayoutTable'
import ModalContent from '../../../Global/ModalContent'
import FormUsersRatings from './Components/FormUsersRatings'

const UsersRatings = () => {
  const modalRef = useRef(null)
  const [dataTable, setDataTable] = useState([])
  const [total, setTotal] = useState(0)
  const [modal, setModal] = useState({
    title: '',
    size: 'extra',
    modalId: null,
    content: null,
  })
  const [closeModal, setCloseModal] = useState(false)
  const [pagePagination, setPagePagination] = useState({
    searchQuery: '',
    limit: 10,
    offset: 0,
  })

  const { loading, error, data, refetch } = useQuery(GET_ALL_USERS_RATINGS, {
    variables: {
      searchQuery: pagePagination.searchQuery,
      limit: pagePagination.limit,
      offset: pagePagination.offset,
    },
    fetchPolicy: 'no-cache',
  })

  useEffect(() => {
    try {
      if (loading) return
      if (error) throw new Error(error.message)

      const dataRows = data.getAllsUserRatings.rows.map((item) => {
        return {
          id: item.id,
          nombre: `${item.userQualified.name} ${item.userQualified.first_name} ${item.userQualified.last_name}`,
          calificacion: item.rating,
          comentario: item.comment,
          row__omit: item,
        }
      })

      setDataTable(dataRows)
      setTotal(data.getAllsUserRatings.count)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [data, loading, error])

  useEffect(() => {
    if (modal.modalId) {
      document.getElementById(`spanModal${modal.modalId}`).click()
    }
  }, [modal])

  useEffect(() => {
    if (closeModal) {
      document.getElementById(`spanModal${modal.modalId}`).click()
      setModal({
        title: '',
        content: null,
        modalId: null,
        size: 'extra',
      })
      setCloseModal(false)
    }
  }, [closeModal])

  const handleCreate = () => {
    setModal({
      title: 'Crear Calificación de Usuario',
      size: 'extra',
      modalId: 'createUserRating',
      content: (
        <FormUsersRatings refetchMain={refetch} setCloseModal={setCloseModal} />
      ),
    })
  }

  const handleEdit = (id, row) => {
    setModal({
      title: 'Editar Calificación de Usuario',
      size: 'extra',
      modalId: 'editUserRating',
      content: (
        <FormUsersRatings
          refetchMain={refetch}
          setCloseModal={setCloseModal}
          ratingId={id}
        />
      ),
    })
  }

  return (
    <>
      <Box
        title="Calificaciones de Usuarios"
        content={
          <>
            <LayoutTable
              hideId
              hideAddNew
              data={dataTable}
              totalCount={total}
              loadingData={loading}
              pagePagination={pagePagination}
              setPagePagination={setPagePagination}
              title={'Calificaciones de Usuarios'}
              showAddNewButton
              handleAddNewButton={handleCreate}
              actionBtnEdit={handleEdit}
            />
          </>
        }
      />
      <span
        id={`spanModal${modal.modalId}`}
        className="invisible"
        data-toggle="modal"
        data-target={`#${modal.modalId}`}
        data-backdrop="static"
        data-keyboard="false"
        data-dismiss="modal"
        ref={modalRef}
      />

      <ModalContent
        idModal={modal.modalId}
        title={modal.title}
        size={modal.size}
        onClose={() => {
          setModal({
            title: '',
            content: null,
            modalId: null,
            size: 'extra',
          })
        }}
        content={modal.content}
      />
    </>
  )
}

export default UsersRatings
